import { render, staticRenderFns } from "./HotDestinationsGrid.vue?vue&type=template&id=7172685a&scoped=true"
import script from "./HotDestinationsGrid.vue?vue&type=script&lang=js"
export * from "./HotDestinationsGrid.vue?vue&type=script&lang=js"
import style0 from "./HotDestinationsGrid.vue?vue&type=style&index=0&id=7172685a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7172685a",
  null
  
)

export default component.exports